// extracted by mini-css-extract-plugin
module.exports = {"ModalBody":"ModalBody_ModalBody__i2g_N"};